import { Injectable } from '@angular/core';
import { countries as countriesData } from './data';
import { cloneDeep } from 'lodash-es';
import { MockApiService } from '@zopup/zop-core';

@Injectable({ providedIn: 'root' })
export class CountriesMockApi {
    private _countries: any[] = countriesData;

    /**
     * Constructor
     */
    constructor(private _mockApiService: MockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {


        // -----------------------------------------------------------------------------------------------------
        // @ Countries - GET
        // -----------------------------------------------------------------------------------------------------
        this._mockApiService
            .onGet('api/countries')
            .reply(() => [200, cloneDeep(this._countries)]);
    }
}
